import { useEffect } from 'react';
import { createUpdateEffect } from '../utils/createUpdateEffect';

export default createUpdateEffect(useEffect);
